import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';
import { Incident, IncidentsService } from 'src/app/api/incidents.service';


export enum OnLinkValues {
  Dismissed = "dismissed",
  LinkSuccess = "linkSuccess",
  CreateIncident = "createIncident",
  LinkError = "linkError"
}

export enum LinkReportModes {
  Link = "link",
  Unlink = "unlink"
}

@Component({
    selector: 'app-link-report',
    templateUrl: './link-report.component.html',
    styleUrls: ['./link-report.component.scss'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LinkReportComponent implements OnInit {


  private _incidents: Incident[] = [];
  @Input()
  set incidents(value: Incident[]) {
    this._incidents = value;

    //TODO: Sort

    //hack in the create new option, if necessary
    if (this.linkMode === LinkReportModes.Link && !this._incidents.find(i => i.workItemId === -1)) {
      this._incidents.unshift({...this.incidentService.emptyIncident, workItemId: -1, summary: "Create a new incident..."});

    }


  }

  get incidents(): Incident[] {
    return this._incidents;
  }

  @Input()
  showActionButtons: boolean = true;

  @Input()
  childIncidentId: number = -1;

  private _linkMode: LinkReportModes = LinkReportModes.Link;

  @Input() 
  set linkMode(value: LinkReportModes) {
    this._linkMode = value;
  }

  get linkMode(): LinkReportModes {
    return this._linkMode;
  }

  @Output()
  onLink = new EventEmitter<OnLinkValues>();

  form = this.fb.group({
    incident: ['']
  })

  constructor(
    private fb: UntypedFormBuilder,
    private incidentService: IncidentsService
  ) { }


  ngOnInit(): void {
  }

  linkIncident() {
    const incident = this.form.value.incident;
    
    if (incident) {

      if (incident.workItemId === -1) {
        this.onLink.emit(OnLinkValues.CreateIncident);
      }
      else {
        this.incidentService.linkIncidents(incident.workItemId, this.childIncidentId).subscribe({
          next: () => {
          this.onLink.emit(OnLinkValues.LinkSuccess);
        },
          error: () => {
            this.onLink.emit(OnLinkValues.LinkError);
          }
      })
      }
    }
    
  }

  unlinkIncident() {
    const incident = this.form.value.incident;

    if (incident) {
      //Child is actually the parent in this case...
      this.incidentService.unlinkIncidents(this.childIncidentId, incident.workItemId).subscribe({
        next: () => {
          this.onLink.emit(OnLinkValues.LinkSuccess);
        },
        error: () => {
          this.onLink.emit(OnLinkValues.LinkError);
        }
      })
    }
  }

 search(event: AutoCompleteCompleteEvent) {
    this._incidents = [...this._incidents]
 }

  getInstructions() {
    if (this.linkMode === LinkReportModes.Link) {
      return "Select an Incident";
    }
    else {
      return "Select a Report";
    }
  }

}
